import React from 'react'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import "./Slider.css"
import { translate } from 'react-i18next'

const reverseFill = {
	0:0,
	1:1,
	2:3,
	3:5,
	4:7,
	5:9,
	6:13
}

const moves = {
	0:0,
	1:1,
	3:2,
	5:3,
	7:4,
	9:5,
	13:6
}

const tooltips = {
	effectSlider: {
		0: "Move The Slider",
		1: "No Support",
		3: "A Little Support",
		5: "Some Support",
		7: "Much Support",
		9: "Very Much Support",
		13: "Overwhelming Support"
	},
	importanceSlider: {
		0: "Move The Slider",
		1: "The Same",
		3: "A Little More",
		5: "Somewhat More",
		7: "Much More",
		9: "Very Much More",
		13: "Overwhelmingly More"
	}
}




class SliderComponent extends React.Component {
	constructor (props) {
		super(props)
		this.state = {
			backgroundCondition: this.props.value === null || this.props.value === 0 ? "pale" : "unpale",
			fill: this.props.value !== null ? this.props.value : 0,
			tooltip: tooltips[this.props.sliderTextType][reverseFill[this.props.value]]
		}
	}
	componentDidMount() {
		if(this.state.fill === 6) {
			document.getElementsByClassName("rc-slider-handle")[0].style.marginLeft = "-23px";
		} else {
				document.getElementsByClassName("rc-slider-handle")[0].style.marginLeft = "-7px";
		}
	}

	moveSliderSlightly = (event) => {
			if(event === 13) {
				document.getElementsByClassName("rc-slider-handle")[0].style.marginLeft = "-23px";
			} else {
				document.getElementsByClassName("rc-slider-handle")[0].style.marginLeft = "-7px";
			}
	}

	handleChange = (e) => {
		this.setState({
			fill: moves[e],
			backgroundCondition: e === 0 ? "pale" : "unpale",
			tooltip: tooltips[this.props.sliderTextType][e]
		}, () => this.props.onChange(moves[e])
		)
		this.moveSliderSlightly(e)
	}

	render () {
		const {t} = this.props
		return (
			<div className="wrapper-flex">
				<div className='wrapper-slider'>
					<div className='tooltip-wrapper' >
						<div className={`tooltip move-${this.state.fill}`}>
							<p className={`${this.state.backgroundCondition === "pale" ? `dim` : "tooltip-text" }`} >
								{t(`${this.state.tooltip}`)}
							</p>
							<div className={`${(this.state.fill > 5) ? `last-arrow `: `arrow-down ` }`}></div>
						</div>
					</div>
					<Slider
						disabled={this.props.disabled}
						className={`slider fill-${this.state.fill}`}
						min={0}
						max={13}
						defaultValue={reverseFill[this.state.fill]}
						marks={{
							0: '',
							1: '',
							3: '',
							5: '',
							7: '',
							9: '',
							13: ''
						}}
						step={null}
						onChange={(e) => this.handleChange(e)}
					/>
					<div className={`lesser-bigger-signs move-${this.state.fill}-signs`} > {"<"} {">"} </div>

			</div>

				<div className="labelContainer">
					<div className="label">
					{this.props.sliderTextType === "effectSlider" ? t("No Support") : t("The Same")}
					</div>
					<div className="label">
					{this.props.sliderTextType === "effectSlider" ? t("Overwhelming Support") : t("Overwhelmingly More")}
					</div>

				</div>
			</div>
		)
	}
}


export default translate()(SliderComponent)










// WEBPACK FOOTER //
// ./src/components/counseling-session/slider2/Slider.js